/** @jsxImportSource @emotion/react */

import Image from 'next/image';

import { media } from '@stories/theming/settings';
import imageLoader from '@utils/imageLoader';

import { SectionHeader, section } from './VitafyAboutUsPage';

export const objectivesItems = [
  {
    href: '/fitness.html',
    backgroundImagePath: '/vitafy/about-us/fitness.png',
    label: 'Fitness'
  },
  {
    href: '/abnehmen.html',
    backgroundImagePath: '/vitafy/about-us/abnehmen.png',
    label: 'ABNEHMEN'
  },
  {
    href: '/ernaehrung.html',
    backgroundImagePath: '/vitafy/about-us/ernaehrung.png',
    label: 'Ernährung'
  },
  {
    href: '/vitamine-co.html',
    backgroundImagePath: '/vitafy/about-us/gesundheit.png',
    label: 'Gesundheit & Pflege'
  }
];

export type BrandTeaserProps = {
  href: string;
  backgroundImagePath: string;
  label: string;
};

export const ObjectiveTeaser: React.FC<BrandTeaserProps> = ({ href, backgroundImagePath, label }) => {
  return (
    <a
      href={href}
      css={{
        [media('tablet')]: { flex: '0 0 calc(50% - 1rem)', margin: '.5rem' },
        [media('desktop')]: { flex: '0 0 calc(25% - 1rem)' }
      }}
    >
      <div
        css={{
          background: 'black',
          marginTop: '1rem',
          overflow: 'hidden',
          position: 'relative',
          aspectRatio: '1',
          ':hover .brand-teaser-image': {
            transform: 'scale(1.1)'
          }
        }}
      >
        <Image
          className="brand-teaser-image"
          loader={imageLoader}
          src={backgroundImagePath}
          alt="Bodylab"
          fill
          // @ts-expect-error static important
          css={{
            transition: 'transform 200ms ease-in-out',
            height: 'auto !important',
            position: 'static !important'
          }}
        />

        <div
          css={{
            background:
              'linear-gradient(hsl(199 98% 33% / 20%) 0%, hsl(197 78% 23% / 20%) 50%, hsl(196 65% 13% / 20%) 100%)',
            backdropFilter: 'blur(30px)',
            color: 'white',
            padding: '1rem',
            position: 'absolute',
            bottom: 0,
            left: 0,
            fontSize: '25px',
            textAlign: 'center',
            textTransform: 'uppercase',
            fontWeight: 'bold',
            width: '100%'
          }}
        >
          <p>{label}</p>
        </div>
      </div>
    </a>
  );
};

const subtitle = `
          <p>
            <span style="font-weight: bold"> Become the best version of yourself! </span>
          </p>
          <p>
            Wir sind fest davon überzeugt, dass jeder seine individuellen Ziele erreichen kann – sei es im
            Bereich Fitness, Gesundheit, Schönheit, Gewichtsreduktion oder Ernährung. Mit einer breiten
            Palette innovativer Produkte unterstützen wir dich auf dem Weg zu deinen Zielen und möchten dir
            helfen, die beste Version von dir selbst zu werden.
          </p>`;

export const Objectives: React.FC = () => {
  return (
    <section css={{ ...section, [media('desktop')]: { padding: '5rem var(--offset) 1rem' } }}>
      <SectionHeader title="Deine Ziele" subtitle={subtitle} />
      <div
        css={{
          marginTop: '2rem',
          [media('tablet')]: { display: 'flex', flexWrap: 'wrap', margin: '1rem .5rem' }
        }}
      >
        {objectivesItems.map((item) => (
          <ObjectiveTeaser key={item.href} {...item} />
        ))}
      </div>
    </section>
  );
};
